import { render, staticRenderFns } from "./chooseForgetPwdType.vue?vue&type=template&id=8d5666f0&scoped=true&"
import script from "./chooseForgetPwdType.vue?vue&type=script&lang=js&"
export * from "./chooseForgetPwdType.vue?vue&type=script&lang=js&"
import style0 from "./chooseForgetPwdType.vue?vue&type=style&index=0&id=8d5666f0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5666f0",
  null
  
)

export default component.exports